import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Button from 'react-bootstrap/Button';
import { ShoppingBag, X, ArrowRight } from 'lucide-react';
import { useCart } from '../context/CartContext';

const CartFloatingBar = () => {
  const { cartServices, removeService } = useCart();
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  if (cartServices.length === 0 || location.pathname === '/agendar-cita') return null;

  const handleSchedule = () => {
    setShow(false);
    navigate('/agendar-cita');
  };

  return (
    <>
      {/* Floating bottom bar */}
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1040,
          background: 'linear-gradient(135deg, #EF60A3 0%, #F49BC3 100%)',
          boxShadow: '0 -4px 20px rgba(239,96,163,0.3)',
        }}
      >
        <div className="container">
          <div className="d-flex align-items-center justify-content-between py-2 px-2">
            <button
              onClick={() => setShow(true)}
              className="btn btn-sm text-white d-inline-flex align-items-center gap-2 border-0"
              style={{ background: 'transparent' }}
            >
              <span
                className="d-inline-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: 28,
                  height: 28,
                  backgroundColor: 'rgba(255,255,255,0.25)',
                }}
              >
                <ShoppingBag size={14} />
              </span>
              <span className="fw-semibold" style={{ fontSize: '0.85rem' }}>
                {cartServices.length} servicio{cartServices.length > 1 ? 's' : ''}
              </span>
              <span style={{ fontSize: '0.75rem', opacity: 0.85 }}>— Ver detalle</span>
            </button>
            <Button
              size="sm"
              variant="light"
              className="rounded-pill fw-semibold d-inline-flex align-items-center gap-1 px-3"
              style={{ fontSize: '0.8rem', color: '#EF60A3' }}
              onClick={handleSchedule}
            >
              Agendar cita <ArrowRight size={14} />
            </Button>
          </div>
        </div>
      </div>

      {/* Offcanvas drawer */}
      <Offcanvas show={show} onHide={() => setShow(false)} placement="bottom" style={{ height: 'auto', maxHeight: '70vh' }}>
        <Offcanvas.Header closeButton style={{ borderBottom: '2px solid #FCE4EC' }}>
          <Offcanvas.Title className="h6" style={{ color: '#EF60A3' }}>
            <ShoppingBag size={18} className="me-2" style={{ display: 'inline' }} />
            {cartServices.length} servicio{cartServices.length > 1 ? 's' : ''} seleccionado{cartServices.length > 1 ? 's' : ''}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-2 pb-4">
          {cartServices.map((svc) => (
            <div
              key={svc.serviceId}
              className="d-flex align-items-start justify-content-between py-2 border-bottom"
            >
              <div style={{ minWidth: 0, flex: 1 }}>
                <small className="text-muted text-uppercase" style={{ fontSize: '0.6rem', letterSpacing: '0.05em' }}>
                  {svc.categoryName}{svc.subCategoryName ? ` / ${svc.subCategoryName}` : ''}
                </small>
                <p className="small fw-medium mb-0">{svc.shortName || svc.label}</p>
              </div>
              <div className="d-flex align-items-center gap-2 ms-2">
                {svc.price && (
                  <span className="small fw-bold" style={{ color: '#EF60A3' }}>{svc.price}</span>
                )}
                <button
                  onClick={() => removeService(svc.serviceId)}
                  className="btn btn-sm p-1"
                  style={{ color: '#E91E63', lineHeight: 1 }}
                  title="Quitar"
                >
                  <X size={14} />
                </button>
              </div>
            </div>
          ))}

          <div className="mt-3 text-end">
            <Button
              variant="primary"
              size="sm"
              className="rounded-pill px-4 d-inline-flex align-items-center gap-2"
              onClick={handleSchedule}
            >
              Agendar cita <ArrowRight size={14} />
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default CartFloatingBar;
